export class StopTaskDto {
  stopped: boolean;
}
